import { render } from "./OfferWrapper.vue?vue&type=template&id=46105ba4&scoped=true&ts=true"
import script from "./OfferWrapper.vue?vue&type=script&lang=ts"
export * from "./OfferWrapper.vue?vue&type=script&lang=ts"

import "./OfferWrapper.vue?vue&type=style&index=0&id=46105ba4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46105ba4"]])

export default __exports__